enum ImportantDateEventEnum {
  InstitutionAdministration = 1,
  RequestCreation = 2,
  RequestSubmission = 3,
  RequestEvaluation = 4,
  ComplaintSubmission = 5,
  ComplaintHandling = 6,
  ResultAnnouncement = 7,
  ContractSigning = 8,
  KindergartenEnrollment = 9,
}

export default ImportantDateEventEnum;
